export const organizationNamePatternAsString =
  "^[0-9A-Za-z'.!-]+(?:\\s[0-9A-Za-z'.!-]+)*$"

export const organizationNamePatternAsRegex = new RegExp(
  organizationNamePatternAsString
)

export const SLACK_WEBHOOK_URL_REGEX =
  '^(https://hooks.slack.com/services)/.+/.+/.+'

export const MS_TEAMS_WEBHOOK_URL_REGEX =
  '^(https://.+.webhook.office.com/).+/.+/.+/.+'

export const domainRegex =
  '^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z0-9][A-Za-z0-9-]{0,61}[A-Za-z0-9]$'

export const DOMAIN_WITHOUT_PROTOCOL_REGEX =
  '^(?!.*://)(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z0-9][A-Za-z0-9-]{0,61}[A-Za-z0-9]$'

export const isUrl = (path) => {
  try {
    const url = new URL(path)
    return url.protocol === 'https:' || url.protocol === 'http:'
  } catch (err) {
    return false
  }
}

export const isValidKeyValidationHost = (path: string): boolean => {
  try {
    const url = new URL(path)

    // URL constructor "fix" a single forward slash, thus not verifying the url format perfectly
    // f.e - `path` is "https:/example.com" will success to construct a new URL, but should fail the host validation
    const reconstructed = `${url.protocol}//${url.hostname}`
    if (!path.startsWith(reconstructed)) {
      return false
    }

    // Only allow HTTPS
    if (url.protocol !== 'https:') {
      return false
    }

    // Disallow localhost (IPv4, IPv6, and hostname forms)
    if (
      url.hostname === 'localhost' ||
      url.hostname === '127.0.0.1' ||
      url.hostname === '::1' ||
      url.hostname === '[::1]'
    ) {
      return false
    }

    return true
  } catch (err) {
    return false
  }
}
